export default __webpack_public_path__ + "static/media/logo.f669b43c.png";